<div class="legend">
  <div class="legend-header">
    <div>
      Route Status
    </div>
    <button mat-icon-button
            class="configure-button"
            (click)="openConfiguration()"
            matTooltip="Configure Route Status Map"
    >
      <mat-icon>settings</mat-icon>
    </button>
  </div>
  <div class="legend-subtitle">
    <span>Service status of routes</span>
  </div>
  <div class="legend-line">
    <div class="legend-item__wrapper">
      <app-line-dash-array-view
        [dashArray]="userTrackStyles.routeStatusNotDone.dasharray"
        [color]="userTrackStyles.routeStatusNotDone.color"
      ></app-line-dash-array-view>

      <div class="legend-item__name">
        Not Done
      </div>
    </div>
    <div class="legend-item__wrapper">
      <app-line-dash-array-view
        [dashArray]="userTrackStyles.routeStatusLevel1.dasharray"
        [color]="userTrackStyles.routeStatusLevel1.color"
      ></app-line-dash-array-view>

      <div class="legend-item__name">
        Done less than 2h
      </div>
    </div>
    <div class="legend-item__wrapper">
      <app-line-dash-array-view
        [dashArray]="userTrackStyles.routeStatusLevel2.dasharray"
        [color]="userTrackStyles.routeStatusLevel2.color"
      ></app-line-dash-array-view>

      <div class="legend-item__name">
        Done 2-5h
      </div>
    </div>
    <div class="legend-item__wrapper">
      <app-line-dash-array-view
        [dashArray]="userTrackStyles.routeStatusLevel3.dasharray"
        [color]="userTrackStyles.routeStatusLevel3.color"
      ></app-line-dash-array-view>

      <div class="legend-item__name">
        Done 5-12h
      </div>
    </div>
  </div>
</div>
